/* eslint-disable no-nested-ternary */
import apiRequest from "shared/services/api";
import {
  getUserPayLoad,
  idPassportAction,
  personalInformation,
  fatcaCrsAction,
  agreementAction,
} from "shared/store/actions";
import { isEmpty } from "lodash";
import withRetry from "shared/helpers/withRetry";
import {
  STORAGE_KEY,
  CLIENT_CLASSIFICATION,
  IS_LOGOUT,
} from "../../constant/index";
import { ACTION_TYPE } from "./actionTypes";

const { APPLICANT } = ACTION_TYPE;

const saveProofOfTransfer = (payload) => ({
  type: APPLICANT.SAVE_PROOF_OF_TRANSFER,
  payload,
});

/**
 * Save PACI (Kuwait Mobile ID) verification status, sent as paciFrontStatus on applicant update
 * @param payload : { updateDate, requestId, qrScanned, getInfoSuccess }
 */
const savePaciFrontStatus = (payload) => ({
  type: APPLICANT.SAVE_PACI_FRONT_STATUS,
  payload,
});

const saveRefCode = (payload) => ({
  type: APPLICANT.REF_CODE,
  payload,
});

const getPdfFail = (payload) => ({
  type: APPLICANT.APPLICANT_PDF_FAIL,
  payload,
});

/** Get CRM PDF form */
const getApplicantPdf = (isGetAll) => async (dispatch, getState) => {
  const {
    languageReducer: { language },
    authReducer: { token, phoneNumber },
  } = getState();

  const data = getUserPayLoad(getState);

  try {
    // get only 6 page

    let res;
    if (isGetAll) {
      res = await withRetry(() =>
        apiRequest.getApplicantPDF(phoneNumber, token, language?.locale),
      );
    } else {
      res = await withRetry(() =>
        apiRequest.getPdfBeforeTandC(token, data, language?.locale),
      );
    }
    dispatch({
      type: APPLICANT.APPLICANT_PDF,
      payload: res,
    });
  } catch (err) {
    // console.log(err);
    dispatch(getPdfFail(err));
  }
};

const checkIfPDFisGenerated = () => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber },
  } = getState();
  try {
    const res = await apiRequest.getApplicantPdfStatus(phoneNumber, token);

    dispatch({
      type: APPLICANT.APPLICANT_PDF_GENERATED,
      payload: res.pdfGenerated,
    });
  } catch (err) {
    console.log(err);
    // dispatch(getPdfFail(err));
  }
};

const refreshAllUrls = () => async (dispatch) => {
  dispatch({
    type: APPLICANT.APPLICANT_FATCA_PDF,
    payload: null,
  });

  dispatch({
    type: APPLICANT.APPLICANT_CRS_PDF,
    payload: null,
  });

  dispatch({
    type: APPLICANT.APPLICANT_NDPF_PDF,
    payload: null,
  });

  dispatch({
    type: APPLICANT.APPLICANT_DPF_PDF,
    payload: null,
  });

  dispatch({
    type: APPLICANT.APPLICANT_CPF_PDF,
    payload: null,
  });

  dispatch({
    type: APPLICANT.APPLICANT_PDF,
    payload: null,
  });

  dispatch({
    type: APPLICANT.APPLICANT_MFT_PDF,
    payload: null,
  });

  dispatch({
    type: APPLICANT.APPLICANT_PDF_REFRESH,
    payload: true,
  });
};

/** Get FATCA PDF form */
const getFatcaPdf = () => async (dispatch, getState) => {
  const {
    languageReducer: { language },
    authReducer: { token, phoneNumber },
  } = getState();

  try {
    const res = await withRetry(() =>
      apiRequest.getOtherPDF(phoneNumber, token, "fatca", language?.locale),
    );
    dispatch({
      type: APPLICANT.APPLICANT_FATCA_PDF,
      payload: res,
    });
  } catch (err) {
    dispatch(getPdfFail(err));
  }
};
const getTCPdf = () => async (dispatch, getState) => {
  const {
    languageReducer: { language },
    authReducer: { token },
  } = getState();

  const data = getUserPayLoad(getState);

  try {
    const res = await withRetry(async () => {
      const url = await apiRequest.getPdfByPage(
        token,
        data,
        6,
        20,
        "",
        "markaz-cob",
        undefined,
        language?.locale,
      );
      // getPdfByPage resolves null on an empty PDF; throw so withRetry retries it
      if (!url) throw new Error("Empty T&C PDF");
      return url;
    });
    dispatch({
      type: APPLICANT.APPLICANT_TC_PDF,
      payload: res,
    });
  } catch (err) {
    dispatch(getPdfFail(err));
  }
};

/** Get CRS PDF form */
const getCrsPdf = () => async (dispatch, getState) => {
  const {
    languageReducer: { language },
    authReducer: { token, phoneNumber },
  } = getState();

  try {
    const res = await withRetry(() =>
      apiRequest.getOtherPDF(phoneNumber, token, "crs", language?.locale),
    );
    dispatch({
      type: APPLICANT.APPLICANT_CRS_PDF,
      payload: res,
    });
  } catch (err) {
    dispatch(getPdfFail(err));
  }
};

/** Get NDPF PDF form */
const getNdpfPdf = () => async (dispatch, getState) => {
  const {
    languageReducer: { language },
    authReducer: { token, phoneNumber },
  } = getState();

  try {
    const res = await apiRequest.getOtherPDF(
      phoneNumber,
      token,
      "ndpf",
      language?.locale,
    );
    dispatch({
      type: APPLICANT.APPLICANT_NDPF_PDF,
      payload: res,
    });
  } catch (err) {
    dispatch(getPdfFail(err));
  }
};

const createApplicantSuccess = (applicantId, phoneNumber) => ({
  type: APPLICANT.CREATE_APPLICANT,
  payload: { applicantId, phoneNumber },
});

const applicantFail = (payload) => ({
  type: APPLICANT.APPLICANT_FAIL,
  payload,
});

/** Create applicant account */
const createApplicant = () => async (dispatch, getState) => {
  const { token, phoneNumber } = getState().authReducer;
  try {
    const res = await apiRequest.createApplicant(phoneNumber, token);
    await dispatch(createApplicantSuccess(res.id, phoneNumber));
  } catch (err) {
    await dispatch(applicantFail(err));
  }
};

/** */
const getCustomSubPfPdf = () => async (dispatch, getState) => {
  const {
    languageReducer: { language },
    authReducer: { token, phoneNumber },
    applicantRootReducer: {
      applicantReducer: { applicantId },
    },
  } = getState();
  try {
    const res = await apiRequest.getCustomSubPF(
      token,
      applicantId,
      phoneNumber,
      language?.locale,
    );
    await dispatch({
      type: APPLICANT.APPLICANT_CUSTOM_SUB_PORTFOLIO,
      payload: res,
    });
  } catch (err) {
    dispatch(getPdfFail(err));
  }
};

/** get all custom uploaded sub agreements/ files */
const getCustomFilePdfs = () => async (dispatch, getState) => {
  const {
    languageReducer: { language },
    authReducer: { token, phoneNumber },
  } = getState();
  const filenames = await apiRequest.getAllUploadedFilenames(
    phoneNumber,
    token,
    language?.locale,
  );
  try {
    const customFileUrls = [];
    if (filenames.length) {
      filenames.forEach((item) => {
        apiRequest
          .getUploadedCustomFileByFilename(
            phoneNumber,
            token,
            item,
            language?.locale,
          )
          .then((res) => {
            customFileUrls.push(res);
          });
      });

      dispatch({
        type: APPLICANT.APPLICANT_CUSTOM_SUB_AGREEMENT,
        payload: customFileUrls,
      });
    }
  } catch (err) {
    await dispatch(applicantFail(err));
  }
};

const updateApplicantSuccess = (
  applicantId,
  phoneNumber,
  applicantPhoneNumbers,
  imarkazRefCode,
) => ({
  type: APPLICANT.UPDATE_APPLICANT_SUCCESS,
  payload: {
    applicantId,
    phoneNumber,
    applicantPhoneNumbers,
    imarkazRefCode,
  },
});

/** Update applicant history */
const updateHistory = (code, codeI18n) => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber, otpTime },
    applicantRootReducer: {
      applicantReducer: { applicantId },
    },
  } = getState();

  const ip = localStorage.getItem(STORAGE_KEY.CURRENT_IP_DATA);
  try {
    await apiRequest.updateHistory(
      token,
      phoneNumber,
      applicantId,
      otpTime,
      ip,
      code,
      codeI18n,
    );
  } catch (err) {
    await dispatch(applicantFail(err));
  }
};

/** Update applicant data */
const updateApplicant =
  (isGenerate = false, signed = false) =>
  async (dispatch, getState) => {
    const {
      authReducer: { token, phoneNumber },
      languageReducer: { language },
      applicantRootReducer: {
        applicantReducer: { applicantId },
      },
    } = getState();
    const data = JSON.parse(JSON.stringify(getUserPayLoad(getState)));

    /**
     * @Todo Need to double check, enable again and make sure it has no effect (FOR TRACKING)
     */
    // update on-boarding category
    const {
      clientDetails,
      authorizedSignatoryInformation: asi,
      imarkazRefCode,
    } = data;
    if (clientDetails.clientClassification) {
      const isDirectCOB = !imarkazRefCode;
      const isQualified =
        clientDetails.clientClassification === CLIENT_CLASSIFICATION.QUALIFIED;
      const isMinor =
        asi.authorityToDeal && asi.authorityToDeal === "legalGuardian";
      const isPOA = !isMinor && asi.isPOAholder && asi.isPOAholder === "Yes";
      let onBoardingCategory = isDirectCOB ? "COB" : "IMARKAZ";
      onBoardingCategory += isQualified ? "_QUALIFIED" : "_RETAIL";
      // eslint-disable-next-line no-nested-ternary
      onBoardingCategory += isMinor ? "_MINOR" : isPOA ? "_POA" : "";

      // previously we use below line to send tracking data
      // clientDetails.clientClassification = CLIENT_CLASSIFICATION[onBoardingCategory];
      // this way create a bug, it overide with the clientDetails ex clientClassifition should be  NW-MAR-CLA-QUA but changed to NW-MAR-CLA-IMA-QUA
      // therefore, we decided to create a new field to store tracking data
      clientDetails.trackingData = {
        clientClassification: CLIENT_CLASSIFICATION[onBoardingCategory],
      };
    }

    if (isEmpty(data)) {
      return false;
    }

    try {
      const res = await withRetry(() =>
        apiRequest.updateApplicant(
          applicantId,
          phoneNumber,
          token,
          data,
          isGenerate,
          language.locale,
          signed,
        ),
      );
      // if (!res) throw new Error();
      if (res) return true;
    } catch (err) {
      await dispatch(applicantFail(err));
      return false;
    }
  };

const saveApplicantOtherDetails = (
  currentLoggedIn,
  lastLoggedIn,
  completionDate,
) => ({
  type: APPLICANT.OTHER_APPLICATION_DETAILS,
  payload: {
    currentLoggedIn,
    lastLoggedIn,
    completionDate,
  },
});

/** Save rework status to the Store */
const saveReworkStatus = (payload) => ({
  type: APPLICANT.REWORK_STATUS,
  payload,
});

/**
 * Get Applicant's details from the back and patch into the store
 * to patch ID/Passport, Personal Information , FATCA and CRS
 */
const getApplicantDetails =
  (withRefCode = false) =>
  async (dispatch, getState) => {
    const {
      authReducer: { token, phoneNumber },
      applicantRootReducer: {
        applicantReducer: { imarkazRefCode, latestRefCode, productCode },
      },
    } = getState();

    try {
      const res = await apiRequest.getApplicant(
        phoneNumber,
        token,
        productCode,
        withRefCode,
      );
      const pepList =
        res.pep.list &&
        res.pep.list.map((item) => ({
          id: item.id,
          name: item.name,
          currentFormerOption: item.currentFormerOption,
          position: item.position,
          otherPosition: item.otherPosition,
          relationship: item.relationship,
        }));

      const personalInformationData = {
        clientDetails: res.clientDetails,
        pep: { ...res.pep, list: pepList },
        bankDetails: {
          ...res.bankDetails,
          usingKNET: res.bankDetails?.usingKNET === false ? "false" : "true",
          cardInfo: res.bankDetails?.cardInfo?.length
            ? res.bankDetails?.cardInfo
            : [
                {
                  index: 1,
                  lastFourDigits: "",
                  expMonth: "",
                  expYear: "",
                  value: "",
                  digitErr: "", // for front only
                  error: "", // for front only
                },
                {
                  index: 2,
                  lastFourDigits: "",
                  expMonth: "",
                  expYear: "",
                  value: "",
                  digitErr: "", // for front only
                  error: "", // for front only
                },
              ],
        },
        sourceOfWealth: {
          ...res.sourceOfWealth,
          ...JSON.parse(res.sourceOfWealth?.sourceOfWealthFundsDetails),
        },
        asi: res.authorizedSignatoryInformation,
        clientProfileForm: res.clientProfileForm,
      };

      const fatcaCrsData = {
        fatca: res.fatca,
        crs: res.crs,
        countryTax: res.countryTax,
      };

      /** Handle old and new refCode */
      const iMarkazRefCodeValue =
        latestRefCode !== ""
          ? latestRefCode === IS_LOGOUT
            ? res.imarkazRefCode
            : latestRefCode
          : res.imarkazRefCode || imarkazRefCode;

      dispatch(saveProofOfTransfer(res.proofOfTransfer));
      dispatch(savePaciFrontStatus(res.paciFrontStatus || null));

      Promise.all([
        /** Get application basic details */ // , res.nextInstruction.emailSent
        await dispatch(
          updateApplicantSuccess(
            res.id,
            phoneNumber,
            res.applicantPhoneNumbers,
            iMarkazRefCodeValue,
          ),
        ),
        // await dispatch(updateApplicantSuccess(res.id, phoneNumber, res.applicantPhoneNumbers, ((res.nextInstruction && res.nextInstruction.emailSent && res.nextInstruction.emailSent) || false)), (res.imarkazRefCode || imarkazRefCode)),

        /** Patch personal information into the store */
        dispatch(
          personalInformation.fetchPersonalInformation(personalInformationData),
        ),

        /** Patch ID & Passport details into the store */
        await dispatch(idPassportAction.fetchIdPassportData(res.idAndPassport)),

        /** Patch Fatca & CRS including Tax list */
        dispatch(fatcaCrsAction.fetchFatcaCrs(fatcaCrsData)),

        /** Patch Agreements */
        await dispatch(agreementAction.fetchAgreements(res.agreements)),

        /** other details  */
        await dispatch(
          saveApplicantOtherDetails(
            res.currentLoggedIn,
            res.lastLoggedIn,
            res.completionDate,
          ),
        ),

        /** get rework status */
        await dispatch(saveReworkStatus(res.rework)),

        /** is Custom Asset Allocation uploaded */
        await dispatch(
          agreementAction.saveIsCustomAAUploaded(
            res.customAssetAllocationUploaded,
          ),
        ),
      ]);
    } catch (err) {
      await dispatch(applicantFail(err));
    }
  };

const sendEmailSuccess = (payload) => ({
  type: APPLICANT.SEND_EMAIL_SUCCESS,
  payload,
});
const sendEmailFail = (payload) => ({
  type: APPLICANT.SEND_EMAIL_FAIL,
  payload,
});

/**
 * Send Email
 */
const sendApplicationToEmail = () => async (dispatch, getState) => {
  const { token, phoneNumber } = getState().authReducer;
  const { language } = getState().languageReducer;
  try {
    const res = await apiRequest.sendEmail(
      phoneNumber,
      token,
      language?.locale,
    );
    await dispatch(sendEmailSuccess(!!res || true));
    await dispatch(updateApplicant());
  } catch (err) {
    await dispatch(sendEmailFail(err));
  }
};

const sendApplicationToEmailAfterSign = () => async (dispatch, getState) => {
  const { token, phoneNumber } = getState().authReducer;
  const { language } = getState().languageReducer;
  try {
    const res = await apiRequest.sendNotificationAfterSign(
      phoneNumber,
      token,
      language?.locale,
    );
    await dispatch(sendEmailSuccess(!!res || true));
    await dispatch(updateApplicant());
  } catch (err) {
    await dispatch(sendEmailFail(err));
  }
};

const resetDSUserData = () => ({
  type: ACTION_TYPE.AUTH.RESET_DS_USER_DETAIL,
});

const resetApplication = () => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber },
    // applicantRootReducer: {
    //   applicantReducer: { applicantId },
    // },
  } = getState();

  Promise.all([
    await apiRequest.resetApplicant(phoneNumber, token),
    // await apiRequest.resetApplicantProgress(applicantId, token),
  ]).then(() => {
    // window.location.replace('/');
    const { PUBLIC_URL } = process.env;
    dispatch(resetDSUserData()); // clear user docuSign data

    window.location.replace(PUBLIC_URL);
  });
};

const saveLatestRefCode = (payload) => ({
  type: APPLICANT.SAVE_LATEST_REF_CODE,
  payload,
});

/** Save product code to the Store */
const saveProductCode = (payload) => ({
  type: APPLICANT.PRODUCT_CODE,
  payload,
});

const applicantAction = {
  saveProofOfTransfer,
  savePaciFrontStatus,
  saveRefCode,
  saveProductCode,

  createApplicant,
  updateApplicant,
  updateHistory,
  getApplicantDetails,
  getApplicantPdf,
  resetApplication,

  getPdfFail,
  getFatcaPdf,
  getCrsPdf,
  getNdpfPdf,
  checkIfPDFisGenerated,

  sendApplicationToEmail,
  refreshAllUrls,
  getTCPdf,
  saveLatestRefCode,

  sendApplicationToEmailAfterSign,

  getCustomFilePdfs,
  getCustomSubPfPdf,
};

export default applicantAction;
